export const Config = {
    notification: {
        snack: {
            errorDuration: 4000
        }
    }
}